module.exports = {"430481001":"蔡子池街道","430481002":"灶市街街道","430481003":"水东江街道","430481004":"五里牌街道","430481005":"三架街道","430481006":"余庆街道","430481100":"黄市镇","430481101":"小水镇","430481102":"公平圩镇","430481104":"三都镇","430481105":"南阳镇","430481107":"夏塘镇","430481108":"龙塘镇","430481109":"哲桥镇","430481110":"永济镇","430481111":"遥田镇","430481112":"新市镇","430481113":"淝田镇","430481114":"大市镇","430481115":"仁义镇","430481116":"南京镇","430481117":"大义镇","430481118":"东湖圩镇","430481119":"马水镇","430481120":"导子镇","430481201":"亮源乡","430481203":"太平圩乡","430481213":"长坪乡","430481214":"太和圩乡","430481215":"坛下乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/430481.json
// module id = 1970
// module chunks = 0